<template>
  <div>
    <Sidebar v-model:visible="activeSidebar" @hide="onHideSidebar()" :style="'width:' + menuWidth + '%'">
      <template #header>
        <hr />
        <div class="p-text-center font-bold" style="font-size: 17px">Главное меню</div>
      </template>
      <ScrollPanel>
        <div class="layout-menu">
          <template v-for="item of menuTask" :key="item.name">
            <div class="menu-category">{{ item.name }}</div>
            <div class="menu-items ml-1">
              <template v-for="child of item.children" :key="child.task_id">
                <div v-if="child.href">
                  <a :href="child.href" target="_blank">{{ child.name }}</a>
                </div>
                <router-link v-if="child.to" :to="{ path: child.to, query: { task_id: child.task_id } }"
                  :data-testid="`item-menu:${child.to}`">
                  <img v-if="child.image !== undefined && child.image !== null" :src="child.image" width="18"
                    v-tooltip="child.name" />
                  <div :class="{ 'ml-1': child.image }">{{ child.name }}</div>
                  <Tag v-if="child.badge" :value="child.badge" severity="danger"></Tag>
                </router-link>
                <template v-if="child.children">
                  <router-link :to="child.children[0].to" v-slot="{ isActive }" custom>
                    <div>
                      <a tabindex="0" @click="toggleSubmenu($event, child.meta[0])">{{ child.name }}<i
                          class="pi pi-chevron-right"></i>
                      </a>
                      <transition name="p-toggleable-content">
                        <div class="p-toggleable-content" v-show="isSubmenuActive(child.meta[0], isActive)">
                          <ul>
                            <li v-for="(submenuitem, i) of child.children" :key="i">
                              <router-link v-if="submenuitem.to" :to="submenuitem.to">
                                {{ submenuitem.name }}</router-link>
                            </li>
                          </ul>
                        </div>
                      </transition>
                    </div>
                  </router-link>
                </template>
              </template>
            </div>
          </template>
        </div>
      </ScrollPanel>
    </Sidebar>
  </div>
</template>

<script setup>
import { ref, watch, onMounted, onUnmounted, defineProps, defineEmits } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';

const props = defineProps({
  active: Boolean,
});

const emit = defineEmits(['hide-sidebar']);

const store = useStore();
const router = useRouter();

const activeSubmenus = ref({});
const menu = ref(null);
const activeSidebar = ref(false);
const loading = ref(true);
const menuGroup = ref(null);
const menuModule = ref(null);
const menuCommand = ref(null);
const menuTask = ref([]);
const menuWidth = ref(19);
const scrollHeight = ref(764);

let menuModuleService = null;
let menuCommandService = null;

function buildMenu() {
  menuTask.value = prepareModuleCommand();
}

function prepareModuleCommand() {
  const moduleCommand = [];
  for (let i = 0; i < menuModule.value.length; i++) {
    for (const command of menuCommand.value) {
      if (command.module_id === menuModule.value[i].module_id) {
        if (!menuModule.value[i].children) menuModule.value[i]['children'] = [];
        menuModule.value[i].children.push({
          task_id: command.task_id,
          name: command.command_title,
          to: '/' + (command.command_body ? command.command_body.split(':')[0] : ''),
          href: command.href,
          badge: command.badge,
          image:
            command.command_icon_index || command.command_icon_index === 0
              ? `/images/24x24/${command.command_icon_index}.png`
              : null,
        });
      }
    }
    if (menuModule.value[i].children) {
      moduleCommand.push({
        id: menuModule.value[i].module_id,
        name: menuModule.value[i].module_name,
        children: menuModule.value[i].children,
      });
    }
  }
  return moduleCommand;
}

function toggleSubmenu(event, name) {
  activeSubmenus.value[name] = !activeSubmenus.value[name];
  activeSubmenus.value = { ...activeSubmenus.value };
  event.preventDefault();
}

function onHideSidebar() {
  emit('hide-sidebar');
}

function isSubmenuActive(name, routerIsActive) {
  if (activeSubmenus.value[name]) {
    return true;
  } else if (routerIsActive) {
    activeSubmenus.value[name] = true;
    return true;
  }
  return false;
}

function handleResize() {
  const w = window.innerWidth;
  menuWidth.value = w > 1024 ? 19 : 19 + ((w - 1024) / 28) * -1;
}

onMounted(() => {
  scrollHeight.value = window.innerHeight - 100;
  window.addEventListener('resize', handleResize);
  handleResize();

  if (store.getters.config('layouts')['appMenuComponent']) {
    const { serviceName, entityName, entitySpec } = store.getters.config('appMenuComponent');
    menuModuleService = store.getters.nameToService(
      serviceName[0],
      null,
      null,
      entityName[0],
      entitySpec[0]
    );
    menuCommandService = store.getters.nameToService(
      serviceName[1],
      null,
      null,
      entityName[1],
      entitySpec[1]
    );
    menuModuleService.getData().then((data) => {
      menuModule.value = data;
      store.commit('SET_MODULES', data);
      menuCommandService.getData().then((data) => {
        menuCommand.value = data;
        buildMenu();
        loading.value = false;
      });
    });
  }
});

onUnmounted(() => {
  window.removeEventListener('resize', handleResize);
});

watch(
  () => props.active,
  (val) => {
    activeSidebar.value = val;
  },
  { immediate: true }
);
</script>

<style lang="scss" scoped>
.p-sidebar {
  padding: 0.6rem;
}

.layout-menu {
  .menu-category {
    display: block;
    color: var(--text-color-secondary);
    font-weight: 600;
    user-select: none;
    padding: 1.5rem 0 1rem 0;
    font-size: 0.857rem;
    text-transform: uppercase;
    border-top: 1px solid var(--surface-d);

    &:first-child {
      border-top: 0 none;
      padding-top: 1rem;
    }
  }

  .menu-items {
    padding: 0 0 1rem 0;
    display: flex;
    flex-direction: column;

    a {
      color: var(--text-color);
      display: flex;
      align-items: center;
      padding: 0.3rem;
      border-radius: 3px;
      cursor: pointer;

      &:hover {
        background-color: var(--surface-c);
      }

      &:focus {
        z-index: 1;
        outline: 0 none;
        transition: box-shadow 0.2s;
        box-shadow: 0 0 0 0.2em;
      }

      &.router-link-exact-active {
        font-weight: 700;
      }

      .p-tag {
        padding-top: 0.125rem;
        padding-bottom: 0.125rem;
        margin-left: 0.5rem;
      }
    }

    div {
      &.router-link-exact-active {
        >a {
          font-weight: 700;
        }

        ul {
          display: block;
        }
      }

      ul {
        padding: 0.5rem 0;
        margin: 0;
        list-style-type: none;

        a {
          font-size: 0.875rem;
          padding: 0.475rem 0.5rem 0.475rem 2rem;
        }
      }
    }
  }
}
</style>